<template>
  <div class="pl-page">

    <!-- Hero -->
    <div class="pl-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-monitor-multiple</v-icon>
        </v-avatar>
        <div>
          <div class="pl-hero__title">Plataformas</div>
          <div class="pl-hero__sub">Plataformas disponibles de e-learning</div>
        </div>
      </div>
      <div class="d-flex align-center" style="gap:8px;">
        <v-btn small dark depressed color="rgba(255,255,255,0.18)" @click="getDatos">
          <v-icon left small>mdi-refresh</v-icon> Actualizar
        </v-btn>
        <v-btn small dark depressed color="rgba(255,255,255,0.18)"
          @click="agregar(); window.$('#modalpla').modal('show')">
          <v-icon left small>mdi-plus</v-icon> Agregar
        </v-btn>
      </div>
    </div>

    <div class="pl-body">

      <!-- Toolbar -->
      <v-card outlined class="pl-toolbar-card mb-4">
        <v-card-text class="py-2 px-4 d-flex align-center" style="gap:10px;">
          <v-chip x-small :color="plataformas.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ plataformas.length }} plataforma{{ plataformas.length !== 1 ? 's' : '' }}
          </v-chip>
          <v-spacer />
          <Alertas ref="xalertar" />
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="pl-table-card">
        <v-data-table
          :headers="headers"
          :items="plataformas"
          :items-per-page="-1"
          hide-default-footer
          dense
          class="pl-table"
          no-data-text="Sin plataformas registradas."
        >
          <!-- Estado -->
          <template v-slot:[`item.estado`]="{ item }">
            <v-chip x-small label
              :color="item.estado ? 'green lighten-5' : 'red lighten-5'"
              :class="item.estado ? 'green--text text--darken-3' : 'red--text text--darken-3'"
              class="font-weight-medium">
              <v-icon left x-small>{{ item.estado ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline' }}</v-icon>
              {{ item.estado ? 'Activo' : 'Inactivo' }}
            </v-chip>
          </template>

          <!-- Token -->
          <template v-slot:[`item.token`]="{ item }">
            <span class="pl-token">{{ item.token }}</span>
          </template>

          <!-- Opciones -->
          <template v-slot:[`item.opciones`]="{ item }">
            <div class="d-flex" style="gap:4px;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon color="indigo darken-1" v-on="on"
                    :disabled="!$store.state.deleteInscripcion"
                    @click="editar(item); window.$('#modalpla').modal('show')">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon color="red darken-1" v-on="on"
                    :disabled="!$store.state.deleteInscripcion"
                    @click="confirmarEliminacion(item)">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </div>
          </template>

        </v-data-table>
      </v-card>

    </div>

    <Modal id="modalpla" :obj="objeto" v-on:exito="modalExito" />
    <notifications group="auth" position="bottom right" />
  </div>
</template>

<script>
import Modal from '@/components/APlataformaModal.vue';
import Alertas from '@/components/AAlertas.vue';
import { parseJsonError } from '@/components/Utils.js';
import { mapState } from 'vuex';
import axios from 'axios';

export default {
  components: { Alertas, Modal },
  data() {
    return {
      objeto: { xtitle: '', xid: 0, xeliminar: false },
      headers: [
        { text: 'Nro',       value: 'index',     width: 60,  sortable: false },
        { text: 'Nombre',    value: 'nombre' },
        { text: 'Dirección', value: 'direccion' },
        { text: 'Estado',    value: 'estado',    width: 110 },
        { text: 'Token',     value: 'token' },
        { text: 'Opciones',  value: 'opciones',  width: 110, sortable: false },
      ],
    };
  },
  computed: {
    ...mapState({
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
      plataformas: (state) => {
        if (state.UNIDAD_NEGOCIO_ID) {
          return state.plataforma.items
            .filter((item) => item.unidad_negocio_id == state.UNIDAD_NEGOCIO_ID)
            .map((item, i) => ({ ...item, index: i + 1 }));
        }
        return [];
      },
    }),
  },
  watch: {
    UNIDAD_NEGOCIO_ID() { this.getDatos(); },
  },
  methods: {
    modalExito() { this.getDatos(); },
    agregar() {
      this.objeto = { xtitle: 'Registrar Nueva Plataforma', xid: 0, xeliminar: false };
    },
    editar(pla) {
      this.objeto.xtitle  = 'Editar Plataforma';
      this.objeto.xid        = pla.id;
      this.objeto.xnombre    = pla.nombre;
      this.objeto.xdireccion = pla.direccion;
      this.objeto.xtoken     = pla.token;
    },
    confirmarEliminacion(pla) {
      const ok = window.confirm(`¿Está seguro de eliminar la plataforma ${pla.nombre} ${pla.direccion}?`);
      if (ok) this.eliminar(pla.id);
    },
    getDatos() {
      this.$refs.xalertar.cargando();
      axios
        .get(`${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas`)
        .then((response) => {
          const data = response?.data;
          const plataformas = data?.datos?.map((plataforma) => {
            const { unidadNegocioId, ...resto } = plataforma;
            return { ...resto, unidad_negocio_id: unidadNegocioId };
          });
          this.$store.dispatch('plataforma/setPlataformas', plataformas);
          this.$refs.xalertar.reset();
        })
        .catch((error) => {
          window.console.error(error);
          this.$notify(parseJsonError(error, 'misInscripciones'));
        })
        .finally(() => { this.$refs.xalertar.reset(); });
    },
    eliminar(plataformaId) {
      this.$refs.xalertar.cargando();
      axios
        .delete(`${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${plataformaId}`)
        .then((response) => {
          const mensaje = response?.data?.mensaje;
          this.$refs.xalertar.success();
          this.$root.$notify.show(mensaje, { color: 'green' });
        })
        .catch((error) => {
          window.console.error(error);
          const mensaje = error?.response?.data?.mensaje;
          this.$root.$notify.show(mensaje, { color: 'red' });
        })
        .finally(() => { this.$refs.xalertar.reset(); this.getDatos(); });
    },
  },
  mounted() { this.getDatos(); },
};
</script>

<style scoped>
.pl-page { min-height: 100vh; background: #f5f7fa; }

.pl-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.pl-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.pl-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.pl-body { padding: 20px 24px; }

.pl-toolbar-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }

.pl-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.pl-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.pl-table >>> tbody tr:hover { background: #f0f4ff !important; }
.pl-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 5px 12px !important;
  vertical-align: middle;
}

.pl-token {
  font-family: monospace;
  font-size: 0.75rem;
  color: #546e7a;
  word-break: break-all;
}
</style>
